"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSearch = void 0;
const react_1 = __importStar(require("react"));
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../../Colors");
const index_1 = require("../../../icons/index");
const Main = typestyle_1.style({
    background: Colors_1.Colors.pink[9],
    color: Colors_1.Colors.grey[0],
    border: 0,
    width: '100%',
    minWidth: 0,
    height: 24,
    padding: `0 12px`,
    paddingLeft: 24,
    borderRadius: 4,
    outline: 0,
    position: 'relative',
    $nest: {
        '&::placeholder': {
            color: Colors_1.Colors.grey[4],
        },
    },
});
const SearchIconContainer = typestyle_1.style({
    position: 'absolute',
    height: 24,
    width: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
});
const XIconContainer = typestyle_1.style({
    position: 'absolute',
    height: 24,
    width: 24,
    right: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 1,
});
const Wrapper = typestyle_1.style({
    position: 'relative',
    maxWidth: '100%',
    padding: 12,
});
exports.MenuSearch = ({ value, onChange, onClear, autoFocus = true }) => {
    const ref = react_1.useRef(null);
    return (react_1.default.createElement("div", { className: Wrapper },
        react_1.default.createElement("span", { className: SearchIconContainer },
            react_1.default.createElement(index_1.Search, null)),
        value && (react_1.default.createElement("span", { onClick: onClear, className: XIconContainer },
            react_1.default.createElement(index_1.X, null))),
        react_1.default.createElement("input", { ref: ref, autoFocus: autoFocus, className: Main, placeholder: "Search...", type: "text", value: value, onChange: (e) => onChange(e.target.value) })));
};
